export default __webpack_public_path__ + "static/media/KITCHEN.57821b26.png";